import React, { useContext, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { UserContext } from '../../context/UserContext';

function CreateTutorScreen() {
    const navigate = useNavigate();
    const [formFields, setFormFields] = useState({full_name: '', email: '', phone: '', password: ''});
    const { setTostMessage } = useContext(TostMessageContext);
    const [cookies, setCookie, removeCookie] = useCookies();
    const {setUserProfile, userProfile, logOutFunction, reloadUser} = useContext(UserContext);
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const submit = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("full_name", formFields.full_name);
        formData.append("email", formFields.email);
        formData.append("phone", formFields.phone);
        formData.append("password", formFields.password);

        try {
            const response = await axios.post(base_url + '/profile/create-tutor.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                setLoading(false);
                setTostMessage({
                    messageType: "success",
                    message: response.data.response,
                });
                setFormFields({full_name: '', email: '', phone: '', password: ''});
                navigate('/all-tutors/profile-settings', {state: { tutor_id: response.data.tutor_id }})
            } else {
                setLoading(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='flex flex-row justify-between'>
                    <div className="w-full px-10 py-[4rem] bg-[#FAFAFA] rounded-lg">
                        <h1 className="text-2xl font-bold text-gray-800 mb-6">Add New Tutor</h1>
                        <div className="flex inline-flex flex-wrap w-full justify-between">
                            <div className='w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Full Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="h-[61px] w-full px-3 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                    placeholder="Enter Full Name"
                                    onChange={(e) => setFormFields({...formFields, full_name: e.target.value})}
                                />
                            </div>

                            <div className='w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Email <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="email"
                                    className="h-[61px] w-full px-3 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                    placeholder="Enter Email"
                                    onChange={(e) => setFormFields({...formFields, email: e.target.value})}
                                />
                            </div>

                            <div className='w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Phone <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="h-[61px] w-full px-3 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                    placeholder="Enter Phone number"
                                    onChange={(e) => setFormFields({...formFields, phone: e.target.value})}
                                />
                            </div>

                            <div className='w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Login Password (Tutor can change this) <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <input
                                        type="text"
                                        className="h-[61px] w-full px-3 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                        placeholder="Enter default password"
                                        onChange={(e) => setFormFields({...formFields, password: e.target.value})}
                                    />
                                </div>
                            </div>
                            
                            <div className='w-full mt-3 flex justify-end'>
                                <ButtonSmall onPress={() => submit()} label={'Add Tutor'} loading={loading} />
                            </div>
                        </div>
                        </div>
                </div>
            </main>
        </div>
    </div>
  );
}

export default CreateTutorScreen;
